export default __webpack_public_path__ + "static/media/baby3 10.17 1.1121da64.png";